import React, { FC } from 'react';
import cs from 'classnames';
import { useTranslation } from '@wix/wix-i18n-config';

import { SignupButton } from '../SignupButton/SignupButton';
import { useIsInboundVersion } from '../../hooks/useIsInboundVersion';
import { subHeaderWithSearchDataHooks as dataHooks } from './SubHeaderWithSearch.dataHooks';
import s from './SubHeaderWithSearch.scss';
import { useBiLogger } from '../../contexts/BILoggerContext';
import { Search } from '../Search/Search';

export const SubHeaderWithSearch: FC = () => {
  const { t } = useTranslation();
  const isInboundVer = useIsInboundVersion();
  const biLogger = useBiLogger();

  const onLinkClick = () => {
    biLogger.reportGeneralAction({
      action: 'start_creating',
      actionValue: 'start_creating_main',
    });
  };

  return (
    <div className={s.container}>
      <div className={cs(s.content, { [s.outboundContent]: !isInboundVer })}>
        <div className={cs(s.subtitle)} data-hook={dataHooks.subtitle()}>
          {isInboundVer
            ? t('app.new.subheader.subtitle.inbound')
            : t('app.new.subheader.subtitle.outbound')}
        </div>
        <div className={s.mainContent}>
          <div
            className={cs(s.title, { [s.outboundTitle]: !isInboundVer })}
            data-hook={dataHooks.title()}
          >
            {isInboundVer
              ? t('app.new.subheader.title.inbound')
              : t('app.new.subheader.title.outbound')}
          </div>
          <div
            className={cs(s.searchInputWrapper, {
              [s.outboundSearchInputWrapper]: !isInboundVer,
            })}
          >
            <Search />
          </div>
        </div>
        <div className={cs(s.description)} data-hook={dataHooks.description()}>
          {isInboundVer
            ? t('app.new.subheader.description.inbound')
            : t('app.new.subheader.description.outbound')}
        </div>
        {!isInboundVer && (
          <SignupButton
            className={s.signUpButton}
            dataHook={dataHooks.signupLink()}
            onClick={onLinkClick}
          />
        )}
      </div>
    </div>
  );
};
